import { format, parseISO } from 'date-fns';

export const getLocalToken = () => localStorage.getItem('token');

export const saveLocalToken = (token: string) => localStorage.setItem('token', token);

export const removeLocalToken = () => localStorage.removeItem('token');

export const formatTime = (timeString: string) => format(parseISO(timeString), 'MM/dd/yyyy h:mmaaa');
